import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-saved-lists-header',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './saved-lists-header.component.html',
    styleUrls: ['./saved-lists-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SavedListsHeaderComponent {

}
